module.exports = __webpack_public_path__ + "img/roulette-wheel.945fd0f5.svg";